module.exports = __webpack_public_path__ + "img/697f003.jpg";